import { render, staticRenderFns } from "./publicClass.vue?vue&type=template&id=bcf4ff82&scoped=true"
import script from "./publicClass.vue?vue&type=script&lang=js"
export * from "./publicClass.vue?vue&type=script&lang=js"
import style0 from "./publicClass.vue?vue&type=style&index=0&id=bcf4ff82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf4ff82",
  null
  
)

export default component.exports